import { render } from "./dpp-barnew.vue?vue&type=template&id=6e3a8bbe"
import script from "./dpp-barnew.js?vue&type=script&lang=js"
export * from "./dpp-barnew.js?vue&type=script&lang=js"

import "./dpp-barnew.vue?vue&type=style&index=0&id=6e3a8bbe&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__